export default "/images/expl-img.png?5ca84f769052d14ae7a8a726914476e3";